// CRA 2 / webpack 4 resolves html-dom-parser and style-to-object to index.mjs,
// so html-react-parser's htmlToDOM / styleToJS imports are not callable at runtime.
const utilities = require('html-react-parser/lib/utilities');
const htmlToDOM = require('html-dom-parser/lib/client/html-to-dom.js');

const domParserOptions = { lowerCaseAttributeNames: false };

const LOGICAL_TO_PHYSICAL = {
  paddingInlineStart: 'paddingLeft',
  paddingInlineEnd: 'paddingRight',
  paddingBlockStart: 'paddingTop',
  paddingBlockEnd: 'paddingBottom',
  marginInlineStart: 'marginLeft',
  marginInlineEnd: 'marginRight',
  marginBlockStart: 'marginTop',
  marginBlockEnd: 'marginBottom',
};

function camelCaseCssProperty(property) {
  return property.replace(/^-ms-/, 'ms-').replace(/-([a-z])/g, (_, character) => (
    character.toUpperCase()
  ));
}

function fallbackStyleToObject(style) {
  const output = {};
  if (typeof style !== 'string' || !style) {
    return output;
  }
  style.split(';').forEach((declaration) => {
    const separator = declaration.indexOf(':');
    if (separator === -1) {
      return;
    }
    const property = declaration.slice(0, separator).trim();
    const value = declaration.slice(separator + 1).trim();
    if (property && value) {
      output[camelCaseCssProperty(property)] = value;
    }
  });
  return output;
}

function applyLogicalToPhysical(styleObject) {
  if (!styleObject || typeof styleObject !== 'object') {
    return styleObject;
  }
  Object.keys(LOGICAL_TO_PHYSICAL).forEach((logical) => {
    const physical = LOGICAL_TO_PHYSICAL[logical];
    if (styleObject[logical] != null && styleObject[physical] == null) {
      styleObject[physical] = styleObject[logical];
    }
  });
  return styleObject;
}

function toReactStyle(style) {
  if (style && typeof style === 'object' && !Array.isArray(style)) {
    return applyLogicalToPhysical(Object.assign({}, style));
  }
  // Do not call style-to-js: webpack 4 binds style-to-object to index.mjs and
  // throws TypeError: (0 , o.default) is not a function; html-react-parser
  // then sets style: {} and drops the attribute.
  return applyLogicalToPhysical(fallbackStyleToObject(style));
}

// Replace html-react-parser's setStyleProp so campaign inline styles survive.
utilities.setStyleProp = function setStyleProp(style, props) {
  if (style === null || style === undefined) {
    return;
  }
  props.style = toReactStyle(style);
};

const domToReact = require('html-react-parser/lib/dom-to-react');

function parseHtml(html, options) {
  if (typeof html !== 'string') {
    throw new TypeError('First argument must be a string');
  }
  if (html === '') {
    return [];
  }
  options = options || {};
  return domToReact(
    htmlToDOM(html, options.htmlparser2 || domParserOptions),
    options,
  );
}

parseHtml.toReactStyle = toReactStyle;

module.exports = parseHtml;
